import { render, staticRenderFns } from "./Confidentiality.vue?vue&type=template&id=09649dd6&scoped=true"
import script from "./Confidentiality.vue?vue&type=script&lang=js"
export * from "./Confidentiality.vue?vue&type=script&lang=js"
import style0 from "./Confidentiality.vue?vue&type=style&index=0&id=09649dd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09649dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09649dd6')) {
      api.createRecord('09649dd6', component.options)
    } else {
      api.reload('09649dd6', component.options)
    }
    module.hot.accept("./Confidentiality.vue?vue&type=template&id=09649dd6&scoped=true", function () {
      api.rerender('09649dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/IDL/Confidentiality.vue"
export default component.exports